import { ReactElement, useEffect, useState } from "react";
import { IParentSize, IRealtimeData } from "../../../../../types";
import { IDashboardComponent, IDoughnutConfig } from "../../../types";
import PieChart from "../../../../../components/charts/pieChart";
import { IPieConfig, ISeries } from "../../../../../components/charts/types";
import { getPalette, getPaletteColor } from "../../../../../configuration/configuration";
import { getFloatValue } from "../../../../../system/utils";

interface IProps {
  parentSize: IParentSize;
  realtime: Record<string, IRealtimeData>;
  component: IDashboardComponent<IDoughnutConfig>;
}

const DoughnutWrapper = ({ component, realtime, parentSize }: IProps): ReactElement | null => {
  const [pieConfig, setPieConfig] = useState<IPieConfig | null>(null);

  useEffect(() => {
    let maximum = 0;
    const series: ISeries[] = component.config.variables.map(v => {
      const value = getFloatValue(realtime[v.code], 0);

      maximum += value;

      return {
        hash: v.hash,
        name: v.title,
        value,
        color: v.color ?? getPaletteColor(),
        unit: v.unit ?? undefined
      };
    });

    setPieConfig({
      width: parentSize.width * (component.config.scale ?? 1),
      height: parentSize.height * (component.config.scale ?? 1),
      maximum: maximum === 0 ? 100 : 0,
      padAngle: 0.02,
      innerRadius: 0.5,
      seriesRadius: 1.1,
      valueRadius: .7,
      showLegend: false,
      showValue: true,
      emptyColor: getPalette().statusColor.empty.background,
      sort: "NAME",
      series,
      scale: component.config.scale ?? 1,
      formatValue: (n: any) => n.toFixed(0)
    });
  }, [ component, realtime, parentSize ]);

  return pieConfig ? <PieChart pieConfig={pieConfig}/> : null;
};

export default DoughnutWrapper;